import React, { useState } from "react";
import { useParams } from "react-router";
import Modal from "../../../../../components/common/form/Modal";
import ButtonTray from "../../../../../components/common/form/ButtonTray";
import { DataTable } from "../../../../../components/common/datatable/DataTable";
import { useCreateSubdivisionAssociationMutation, useSearchSubDivisionQuery } from "../../../../data/subDivision/subDivisionApi";
import { DataTableColumn } from "../../../../../components/common/datatable/DataTableTypes";
import { FaMagnifyingGlass } from "react-icons/fa6";


interface Props {
    show: boolean;
    setShow: any;
    state?: string;
    countyId?: string;
}


const AddSubdivisionForm: React.FC<Props> = ({ show, setShow, state, countyId }) => {
    let { associationId } = useParams();
    const [subdivisionId, setSubdivisionId] = useState<string | null>(null);
    const [disable, setDisable] = useState<boolean>(true);
    const [createApi, createApiRes] = useCreateSubdivisionAssociationMutation();


    const selectSubdivision = (props: any) => {
        return (
            <>
                <span className="active cursor" id={props.row.original.id + "1"}>{props.value}</span>
            </>
        );
    };

    const handleAssociationSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (subdivisionId) {
            setDisable(true);
            await createApi({
                associationsId: associationId,
                subdivisionId: subdivisionId,
            });
            setShow(false);
        }
    };

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "subdivisionKey.name",
            cell: (props: any) => selectSubdivision(props),
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        },
        {
            label: "Subdivision Code",
            accessor: "subdivisionCode",
            cell: (props: any) => selectSubdivision(props),
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Code...",
                    filterModalKey: "subdivisionCode",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "subdivisionCode"
            }],
        },
        {
            label: "County",
            accessor: "county.countyName"
        }
    ]


    const customFilter = {
        state,
        county: countyId
    };

    return (
        <Modal
            title={"Subdivision Selector"}
            show={show}
            setShow={setShow}
            className={"w-3/6 bg-text-0 text-surface-0"}
            fields={
                <>
                    <div className="modal-body">
                        <div className="table_data">
                            <div className="table-responsive jurisdictions_selector">
                                <DataTable
                                    columns={columns}
                                    actions={{
                                        fetchAction: useSearchSubDivisionQuery,
                                    }}
                                    defaultFilter={{
                                        pageNumber: 0,
                                        pageSize: 10,
                                        ...customFilter
                                    }}
                                    renderOptions={{ skipUserSettingRender: true, skipButtonSectionRender: true, skipFilterButtonRender: true }}
                                    appendFilterToUrl={false}
                                    rowSelectionOptions={{
                                        enableRowSelection: true,
                                        onSelectionChange: (selectedRows) => {
                                            const [row] = Array.from(selectedRows);
                                            if (row) {
                                                setSubdivisionId(row.id)
                                            }
                                        },
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                    <div className="mt-4 border-t border-t-surface-5 flex justify-end">


                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Cancel",
                                        onClick: () => setShow(false),
                                        type: "cancel",
                                    },
                                    buttonType: "button"
                                },
                                {
                                    buttonProps: {
                                        btnText: "Submit",
                                        onClick: (e: any) => {
                                            handleAssociationSubmit(e)
                                        },
                                        type: "submit",
                                        isLoading:createApiRes?.isLoading
                                    },
                                    buttonType: "button"
                                }
                            ]}
                            align={"end"}
                            gap={2}
                        />

                    </div>

                </>
            }
        />
    );
};

export default AddSubdivisionForm;